import React from 'react'
import LoadingSpin from './components/LoadingSpin'
import LoginForm from './components/LoginForm'
import MainPage from './pages/MainPage'
import Helmet from 'react-helmet'
import { BrowserRouter as Router, Link, Redirect, Route } from 'react-router-dom'
import DefaultAvatar from '../assets/images/avatar.png'
import ClientsEdit from './pages/clients/ClientsEdit'
import ClientsList from './pages/clients/ClientsList'
import ClientsStats from './pages/clients/ClientsStats'
import ClientsUsers from './pages/clients/ClientsUsers'
import { Button } from 'react-bootstrap'
import { config } from './components/Constants'
import TasksList from './pages/tasks/TasksList'
import SupportList from './pages/support/SupportList'
import MessagesEdit from './pages/messages/MessagesEdit'
import MessagesList from './pages/messages/MessagesList'
import UsersList from './pages/users/UsersList'
import ClientsAdd from './pages/clients/ClientsAdd'
import UsersEdit from './pages/users/UsersEdit'
import Tools from './pages/tools/Tools'
import LogsList from "./pages/logs/LogsList";
import ToolsChangeServicePasswd from "./pages/tools/ToolsChangeServicePasswd";

class Main extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null,
      isLoaded: false,
      isLoggedIn: false,
      menuExpanded: false,
      redirect: null,
      avatar: null,
      user: {}
    }
    this.MessageStatuses = [
      { id: 1, name: 'Aktywny' },
      { id: 2, name: 'Nieaktywny' },
      { id: 3, name: 'Archiwalny' },
    ]

    this.menuCollapse = this.menuCollapse.bind(this)
    this.menuExpandCollapse = this.menuExpandCollapse.bind(this)
    this.updateStateHandler = this.updateStateHandler.bind(this)
    this.logout = this.logout.bind(this)
  }

  componentDidMount () {
    fetch(config.API_URL + '/api/isLoggedIn', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(
        (result) => {
          if (result.error) {
            this.setState({
              isLoaded: true,
              isLoggedIn: false,
              user: null,
              avatar: null,
              error: result.error
            })
          } else if (result) {
            let avatar = null
            if (result.user) {
              avatar = result.user.avatar
            }
            this.setState({
              isLoaded: true,
              isLoggedIn: result.isLoggedIn,
              user: result.user,
              avatar: avatar
            })
          }
        },
        // Uwaga: to ważne, żeby obsłużyć błędy tutaj, a
        // nie w bloku catch(), aby nie przetwarzać błędów
        // mających swoje źródło w komponencie.
        (error) => {
          this.setState({
            isLoaded: true,
            isLoggedIn: false,
            user: null,
            avatar: null,
            error: error
          })
        }
      )
  }

  logout () {
    this.setState({
      isLoaded: false,
    })
    fetch(config.API_URL + '/api/logout', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(
        (result) => {
          if (result.error) {
            this.setState({
              isLoaded: true,
              error: result.error
            })
          } else if (result) {
            this.setState({
              isLoaded: true,
              isLoggedIn: result.isLoggedIn,
              user: result.user,
              redirect: '/'
            })
          }
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error: error
          })
        }
      )
  }

  updateStateHandler (state) {
    this.setState(state)
  }

  menuExpandCollapse () {
    this.setState({
      menuExpanded: !this.state.menuExpanded
    })
  }

  menuCollapse () {
    this.setState({
      menuExpanded: false
    })
  }

  render () {
    const { error, isLoaded, isLoggedIn, menuExpanded, user, redirect, avatar } = this.state
    let useravatar = DefaultAvatar
    if (avatar) {
      useravatar = avatar
    }
    if (error) {
      return (
        <React.Fragment>
          <Helmet>
            <meta charSet="utf-8"/>
            <title>Horeca Idea Panel - Błąd!</title>
          </Helmet>
          <div>{error}</div>
        </React.Fragment>
      )
    } else if (!isLoaded) {
      return (
        <React.Fragment>
          <Helmet>
            <meta charSet="utf-8"/>
            <title>Horeca Idea Panel - Trwa ładowanie danych...</title>
          </Helmet>
          <LoadingSpin/>
        </React.Fragment>
      )
    } else if (!isLoggedIn) {
      return (
        <React.Fragment>
          <Helmet>
            <meta charSet="utf-8"/>
            <title>Horeca Idea Panel - Zaloguj się!</title>
          </Helmet>
          <LoginForm/>
        </React.Fragment>
      )
    } else {
      return (
        <Router>
          {redirect !== null ? <Redirect to={redirect}/> : ''}
          <Helmet>
            <meta charSet="utf-8"/>
            <title>Horeca Idea Panel</title>
            <script src="https://kit.fontawesome.com/1030efff8c.js" crossOrigin="anonymous"></script>
          </Helmet>
          <div id="dashboard">
            <header>
              <Button className="menu" onClick={this.menuExpandCollapse}>
                <i className="fas fa-bars"></i>
              </Button>
              <div className="header-profile">
                <img src={useravatar}/><strong>{user.username}</strong>
              </div>
              <Button className="logout" onClick={this.logout}>
                <i className="fas fa-sign-out-alt"></i>
              </Button>
            </header>
            <section>
              <Route exact path="/" component={MainPage}/>
              <Route exact path="/clients" component={ClientsList}/>
              <Route exact path="/clients/edit/:id" component={ClientsEdit}/>
              <Route exact path="/clients/analytics/:id" component={ClientsStats}/>
              <Route exact path="/clients/users/:id" component={ClientsUsers}/>
              <Route exact path="/clients/add" component={ClientsAdd}/>
              <Route exact path="/users" render={(props) => <UsersList user={user}/>}/>
              <Route exact path="/users/edit" render={({ match }) => <UsersEdit user={user} match={match} updateStateHandler={this.updateStateHandler}/>}/>
              <Route exact path="/users/edit/:id" render={({ match }) => <UsersEdit user={user} match={match} updateStateHandler={this.updateStateHandler}/>}/>
              <Route exact path="/tools" component={Tools}/>
              <Route exact path="/tools/changeServicePasswd" component={ToolsChangeServicePasswd}/>
              <Route exact path="/tasks" component={TasksList}/>
              <Route exact path="/logs" component={LogsList}/>
              <Route exact path="/logs/:year" component={LogsList}/>
              <Route exact path="/support" component={SupportList}/>
              <Route exact path="/messages" render={({ match }) => <MessagesList MessageStatuses={this.MessageStatuses} match={match}/>}/>
              <Route exact path="/messages/edit" render={({ match }) => <MessagesEdit MessageStatuses={this.MessageStatuses} match={match}/>}/>
              <Route exact path="/messages/edit/:id" render={({ match }) => <MessagesEdit MessageStatuses={this.MessageStatuses} match={match}/>}/>
            </section>
            <menu className={menuExpanded ? 'showmenu' : ''}>
              <Button className="menu-close" onClick={this.menuExpandCollapse}>
                <i className="fas fa-times"></i>
              </Button>
              <div className="user">
                <img src={useravatar}/>
                {user.username}
              </div>
              <div>
                <h3>Główna</h3>
                <ul>
                  <li>
                    <Link to="/" onClick={this.menuCollapse}><i className="fas fa-home"></i> Strona główna</Link>
                  </li>
                  <li>
                    <Link to="/clients" onClick={this.menuCollapse}><i className="fas fa-hotel"></i> Obiekty</Link>
                  </li>
                  <li>
                    <Link to="/tools" onClick={this.menuCollapse}><i className="fas fa-tools"></i> Narzędzia</Link>
                  </li>
                  <li>
                    <Link to="/tasks" onClick={this.menuCollapse}><i className="fas fa-thumbtack"></i> Zadania</Link>
                  </li>
                  <li>
                    <Link to="/support" onClick={this.menuCollapse}><i className="fas fa-comments"></i> Zgłoszenia klientów</Link>
                  </li>
                  <li>
                    <Link to="/messages" onClick={this.menuCollapse}><i className="fas fa-comment-dots"></i> Komunikaty</Link>
                  </li>
                  <li>
                    <Link to="/messages" onClick={this.menuCollapse}><i className="fas fa-envelope"></i> Mailing</Link>
                  </li>
                  <li>
                    <Link to="/logs" onClick={this.menuCollapse}><i className="fas fa-passport"></i> Logi logowań</Link>
                  </li>
                </ul>
              </div>
              <div>
                <h3>Admin</h3>
                <ul>
                  <li>
                    <Link to="/users" onClick={this.menuCollapse}><i className="fas fa-users"></i> Użykownicy</Link>
                  </li>
                  <li>
                    <Link to="/permissions" onClick={this.menuCollapse}><i className="fas fa-tasks"></i> Uprawnienia</Link>
                  </li>
                  <li>
                    <Link to="/settings" onClick={this.menuCollapse}><i className="fas fa-cogs"></i> Ustawienia</Link>
                  </li>
                </ul>
              </div>
            </menu>
            <footer>
              &copy; 2020. Idea Profit Sp. z o.o.
            </footer>
          </div>
        </Router>
      )
    }
  }
}

export default Main
